import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const UploadCv = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { fill: "#B3B3B2", d: "M36,0H0v48h36V0z" }),
    React.createElement("path", { fill: "#CACAC8", d: "M0,0h36v6H0V0z" }),
    React.createElement("polygon", { fill: "#F5F5F3", points: "26.014,25.8 17.8,17.586 9.586,25.8 11,27.214 16.8,21.414 16.8,36 18.8,36 18.8,21.414\n\t24.6,27.214 " })), 'UploadCv', { width: 48, height: 48, viewBox: '0 0 36 48' });
export default UploadCv;
